import { createStyles, makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            padding: theme.spacing(2),
            backgroundColor: theme.palette.common.white,
        },
        search: {
            width: '100%',
            border: 0,
            backgroundColor: '#f8f8f8',
        },
    }),
);
